import { cn } from "@/lib/utils";

// Asset Constants
export const ASSETS = {
  imgHybridRewards: "/assets/onboarding/hybrid-rewards-bg.webp", // Color theme background
  imgLinkTreeBg: "/assets/onboarding/linktree-bg.webp", // Transparent link tree image
  imgLogo8Ball: "/assets/onboarding/8ball-logo.webp",
  imgCheckIcon: "/assets/onboarding/gem-icon.webp",
  imgGem: "/assets/onboarding/gem-icon.webp",
  imgDarkenBg: "/assets/onboarding/darken-button-bg.webp",
};

export type GemsProps = {
  className?: string;
  bonus?: boolean;
  value?: string;
  success?: boolean;
};

export function Gems({
  className,
  bonus = false,
  value = "40",
  success = true,
}: GemsProps) {
  return (
    <div
      className={cn(
        "border border-solid relative rounded-md shrink-0 h-5",
        success ? "border-[#abf790]" : "border-white/10",
        className,
      )}
    >
      <div className="flex gap-1 items-center justify-center px-2 py-0 relative z-[2]">
        {bonus && (
          <span className="font-medium text-xs text-[#fafafa] mr-1">Bonus</span>
        )}
        <span
          className={cn(
            "font-medium text-xs",
            success ? "text-[#abf790]" : "text-[#fafafa]",
          )}
        >
          {value}
        </span>
      </div>
    </div>
  );
}

export function UtilityArrowForward({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Arrow forward"
    >
      <title>Arrow forward</title>
      <path
        d="M4.16602 10H15.8327"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4.16669L15.8333 10L10 15.8334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
